import { useState } from "react";
import MailHistory from "./MailHistory";
import SMSHistory from "./SmsHistory";

export default function MessageHistory() {
    const [activeTab, setActiveTab] = useState("sms");
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);

        const day = date.getUTCDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getUTCFullYear();

        const weekday = date.toLocaleString("en-US", { weekday: "long" });

        let hours = date.getUTCHours();
        const minutes = date.getUTCMinutes().toString().padStart(2, "0");

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // convert 0 → 12, 13 → 1

        return `${day} ${month}, ${year}, ${weekday}, ${hours}:${minutes} ${ampm}`;
    };


    return (
        <div className="p-5 bg-white shadow rounded-lg">
            <div className="flex gap-3 mb-5">
                <button
                    onClick={() => setActiveTab("sms")}
                    className={`px-4 py-2 rounded-lg border 
                        ${activeTab === "sms"
                            ? "bg-indigo-600 text-white border-indigo-600 shadow-md"
                            : "bg-white text-gray-700 border-gray-300"}`}
                >
                    SMS History
                </button>

                <button
                    onClick={() => setActiveTab("email")}
                    className={`px-4 py-2 rounded-lg border 
                        ${activeTab === "email"
                            ? "bg-indigo-600 text-white border-indigo-600 shadow-md"
                            : "bg-white text-gray-700 border-gray-300"}`}
                >
                    Email History
                </button>
            </div>

            {activeTab === "email" ? (
                <MailHistory baseUrl={baseUrl} formatDate={formatDate} />
            ) : (
                <SMSHistory baseUrl={baseUrl} formatDate={formatDate} />
            )}
        </div>
    );
}
